import React, { createContext, memo, useContext, useMemo } from "react";
import PropTypes from "prop-types";

const ProjectContext = createContext("global.project");

const ProjectContextProvider = memo(({ project, children }) => {
    return (
        <ProjectContext.Provider value={project}>
            {children}
        </ProjectContext.Provider>
    );
});

ProjectContextProvider.defaultProps = {
    children: null,
    project: undefined,
};

ProjectContextProvider.propTypes = {
    children: PropTypes.node,
    project: PropTypes.string,
};

ProjectContextProvider.displayName = "ProjectContextProvider";

export const useProjectContext = () => {
    const project = useContext(ProjectContext);
    return useMemo(() => ({ project }), [project]);
};

export default ProjectContextProvider;
